import React from 'react';
import { styled } from "styled-components";
import icon from '../../assets/icon/attachment.svg';

const Wrapper = styled.div`
  height: 38px;
  p {
    padding-left: 45px;    
  }
  a {
    padding-left: 45px;
    color: ${p => p.color};

    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    
    text-decoration: unset;

    &::before {
      content: '';
      position: absolute;
      left: 13px;
      width: 38px;
      height: 38px;
      background-image: url(${icon});
      background-repeat: no-repeat;
    }
  }
`;

const Attachment = ({ link, title, size, color }) => {
  return <Wrapper color={color || '#000'}>
    <a href={link} target='_blank'>{title}</a>
    <p>{size}</p>
  </Wrapper>
};

export default Attachment;
